const runValidators = (value, validators) => {
  let error;
  validators.some((validator) => {
    const result = validator(value);
    if (result.errors.length > 0) {
      error = result.errors[0];
      return true;
    } else {
      return false;
    }
  });
  return error;
};

export default runValidators;
